// src/utils/imageUtils.js
//this is for the Sanity Client 
import React, { useState } from 'react';
import { urlFor } from './sanityClient'; // Changed from '../sanityClient' to './sanityClient'

/**
 * Safely gets image URL from Sanity image data
 */
export const getSafeImageUrl = (imageData, options = {}) => {
  if (!imageData) return null;
  
  try {
    // Handle direct URL strings
    if (typeof imageData === 'string') return imageData;
    
    // Handle asset with direct URL
    if (imageData.asset && imageData.asset.url) return imageData.asset.url;
    
    // Standard Sanity image with asset._ref
    if (imageData.asset && imageData.asset._ref) {
      const width = options.width || 800;
      const height = options.height;
      
      let imageUrl = urlFor(imageData).width(width);
      if (height) imageUrl = imageUrl.height(height);
      if (options.fit) imageUrl = imageUrl.fit(options.fit);
      if (options.format) imageUrl = imageUrl.format(options.format);
      
      return imageUrl.url();
    }
    
    return null;
  } catch (err) {
    console.error("Error generating image URL:", err);
    return null;
  }
};

/**
 * Safe image component with fallback for Sanity images
 */
export const SafeImage = ({ image, alt, className, fallbackText = "Image unavailable" }) => {
  const [hasError, setHasError] = useState(false);
  const imageUrl = getSafeImageUrl(image);
  
  if (!imageUrl || hasError) {
    return (
      <div className={`${className} bg-gray-200 flex items-center justify-center`}>
        <span className="text-gray-500 text-sm">{fallbackText}</span>
      </div>
    );
  }
  
  return (
    <img 
      src={imageUrl}
      alt={alt || "Image"}
      className={className || ""}
      onError={() => setHasError(true)}
    />
  );
};